define([
	"dojo/_base/declare",
	"csi/table/Copy",
	"Quality/TestRunActionMixin"
], function(declare,Copy,TestRunActionMixin) {

	return declare([Copy, TestRunActionMixin], {
		/**
		 * Hide unnecessary fields from copy form
		 */
		onCreatePopupDefView: function(defView) {
			this._hideFields(defView, this.m_cache);
		},

		onCreatePopup: function(/*csi.view.Widget*/view) {
			this._disableColorOrSample(view);
			this.inherited(arguments);
		}
	});
});